import { USD_TO_GBP } from './_barrel.js';

        function formatMoney(usdValue, currency, decimals) {
            const v = currency === 'GBP' ? usdValue * USD_TO_GBP : usdValue;
            const symbol = currency === 'GBP' ? '£' : '$';
            const d = decimals != null ? decimals : (Math.abs(v) < 0.01 ? 6 : Math.abs(v) < 1 ? 4 : 2);
            return symbol + v.toFixed(d);
        }

export { formatMoney };
